import { BusinessHealthResponse } from '../types';
import HealthMetrics from './HealthMetrics';
import BusinessHealthIndicator from './HealthIndicator';
import ReportingPeriodCaption from './ReportingPeriodCaption';
import { generateHealthSummaryMarkdown } from './helpers/generateHealthSummary';
import {
    WidgetContainer,
    ContentContainer,
    StyledMarkdownOutput,
    WidgetCard,
    HealthMetricsContainer,
} from './styled';

export interface HealthWidgetProps {
    data?: BusinessHealthResponse;
    isLoading?: boolean;
}

const BusinessHealthWidget = ({ data, isLoading }: HealthWidgetProps) => (
    <WidgetContainer>
        <WidgetCard>
            {data?.period && <ReportingPeriodCaption period={data.period} />}
            <BusinessHealthIndicator isLoading={isLoading} data={data?.healthscore} />
            <ContentContainer $hasPeriod={Boolean(data?.period)}>
                <StyledMarkdownOutput value={generateHealthSummaryMarkdown(data)} />
            </ContentContainer>
        </WidgetCard>
        <HealthMetricsContainer>
            <HealthMetrics isLoading={isLoading} data={data} />
        </HealthMetricsContainer>
    </WidgetContainer>
);

export default BusinessHealthWidget;
